/*=========================================================================================
  File Name: sonarlareas.store.js
  Namespace: sonarlareas
  Description: Vuex Sonar Learning Areas Store
==========================================================================================*/
import {
  listSonarLAreas
} from '@/services/sonar.service.js'

const state = {
  learningAreas: {},
  selectedLearningArea: null
}

const getters = {
  learningAreaNames: state => Object.keys(state.learningAreas),
  selectedAreaGroups: state => {
    if (state.selectedLearningArea && state.learningAreas[state.selectedLearningArea]) {
      return state.learningAreas[state.selectedLearningArea].data;
    }
    return [];
  },
}

const mutations = {
  SET_LEARNING_AREAS(state, areas) {
    state.learningAreas = areas
  },
  SET_SELECTED_LEARNING_AREA(state, area) {
    state.selectedLearningArea = area
  }
}

const actions = {
  async getAllSonarLAreas({ commit }) {
    const response = await listSonarLAreas()
    if (response) {
      commit('SET_LEARNING_AREAS', response)
    }
    return response
  },
  selectLearningArea({ commit }, area) {
    commit('SET_SELECTED_LEARNING_AREA', area)
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}